import { useSelector } from 'react-redux';
import { getCookieByName } from '../utils/functions';

export function useEnableDefaultLogo() {
  const enableDefaultLogoCookie = getCookieByName('enableDefaultLogo', true);

  const enableDefaultLogoConfig = useSelector(
    (state: any) => state.workflow.flowDefiningAttributes?.enableDefaultLogo
  );

  if (
    enableDefaultLogoCookie !== null &&
    enableDefaultLogoCookie !== undefined
  ) {
    return enableDefaultLogoCookie as boolean;
  }
  if (
    enableDefaultLogoConfig !== null &&
    enableDefaultLogoConfig !== undefined
  ) {
    return enableDefaultLogoConfig as boolean;
  }
  return false;
}
